import { NavigationGuardReturn, RouteLocationNormalized } from 'vue-router';
import DentalApplication from '@/application/dental/infrastructure/views/DentalApplication.vue';
import SaveAndExitSuccess from '@/application/shared/infrastructure/views/SaveAndExitSuccess.vue';
import PlanList from '@/planList/infrastructure/views/PlanList.vue';
import QuoteForm from '@/quote/infrastructure/views/QuoteForm.vue';
import EnrollmentLayout from '@/shared/infrastructure/layouts/EnrollmentLayout.vue';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import { checkApplicationSanity, validateUUIDGuard } from '@/application/shared/infrastructure/routeGuards';
import DentalAndVisionContinueApplying from '@/shared/infrastructure/views/DentalAndVisionContinueApplying.vue';
import { CarrierList } from '@hfc/ui-core';

export const dentalRouter = {
  path: '/dental',
  name: 'Dental',
  redirect: {
    name: 'DentalQuote'
  },
  children: [{
    path: 'quote',
    name: 'DentalQuote',
    props: {
      applicationType: APPLICATION_TYPES.DENTAL,
      titlePrefix: 'Off Exchange'
    },
    component: QuoteForm,
  }, {
    path: 'quote-senior',
    name: 'DentalQuoteSenior',
    props: {
      applicationType: APPLICATION_TYPES.DENTAL,
      titlePrefix: 'Senior'
    },
    component: QuoteForm,
  }, {
    path: 'plan-list',
    name: 'DentalPlanList',
    props: {
      applicationType: APPLICATION_TYPES.DENTAL,
    },
    component: PlanList,
    beforeEnter: (_to: RouteLocationNormalized, _from: RouteLocationNormalized): NavigationGuardReturn => checkApplicationSanity('dentalQuote', 'DentalQuote')
  }, {
    path: '',
    name: 'DentalApplicationLayout',
    component: EnrollmentLayout,
    props: {
      applicationType: APPLICATION_TYPES.DENTAL
    },
    children: [{
      path: 'application',
      name: 'DentalApplication',
      component: DentalApplication,
      beforeEnter: (_to: RouteLocationNormalized, _from: RouteLocationNormalized): NavigationGuardReturn => checkApplicationSanity('dentalPlan', 'DentalPlanList')
    }, {
      path: 'application/:uuid',
      name: 'DentalApplicationResume',
      component: DentalApplication,
      beforeEnter: (to: RouteLocationNormalized, _from: RouteLocationNormalized): NavigationGuardReturn => validateUUIDGuard(to, 'DentalApplication')
    }]
  }, {
    path: 'application/:uuid/continue-applying',
    name: 'DentalApplicationContinueApplying',
    component: DentalAndVisionContinueApplying,
    props: {
      applicationType: APPLICATION_TYPES.DENTAL
    }
  }, {
    path: 'save-and-exit',
    name: 'DentalSaveAndExit',
    component: SaveAndExitSuccess,
    beforeEnter: (_to: RouteLocationNormalized, _from: RouteLocationNormalized): NavigationGuardReturn => checkApplicationSanity('dentalSaveAndExit', 'DentalQuote'),
    props: {
      applicationType: APPLICATION_TYPES.DENTAL,
      carrier: CarrierList.BlueShield
    },
  }]
};
